/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Directive, Input } from '@angular/core';
import { Bean, GridOptions, IRowNodeStage, RowNode, StageExecuteParams } from 'ag-grid-community';
import { isNil, keyBy } from 'lodash';
import { GRID_FEATURE, GridFeature, GridFeatureInitParams, GridFeatureReadyParams } from '../feature.interfaces';

@Bean('groupStage')
@Directive({
  selector: '[ghGridPrecalculatedTreeData]',
  providers: [{
    provide: GRID_FEATURE,
    useExisting: GridPrecalculatedTreeDataDirective,
    multi: true,
  }],
})
export class GridPrecalculatedTreeDataDirective implements GridFeature, IRowNodeStage {
  seedBeans = {
    'groupStage': this,
  };

  @Input('ghGridPrecalculatedTreeData') getLevel: TransformFn<Maybe<any>, Maybe<any[]>>;
  @Input('ghGridPrecalculatedTreeDataExpanded') expanded: string;

  private getRowNodeId: TransformFn<any, any>;

  initGrid(params: GridFeatureInitParams): void {
    // nothing to do
  }

  enhanceGridOptions(options: GridOptions): void {
    const { getLevel } = this;
    const { getRowNodeId } = options;

    if (isNil(getRowNodeId)) {
      throw new Error(`ghGridPrecalculatedTreeData: getRowNodeId should be defined`);
    }

    if (isNil(getLevel)) {
      throw new Error(`ghGridPrecalculatedTreeData: getLevel should be defined`);
    }

    this.getRowNodeId = getRowNodeId;
  }

  onGridReady(params: GridFeatureReadyParams): void {
    // nothing to do
  }

  onDestroy(): void {
    // nothing to do
  }

  execute(params: StageExecuteParams): any {
    const { rowNode } = params;

    // if (rowNodeTransaction) {
    //   this.groupByRowNodeTransaction(rowNodeTransaction, rowNodeOrder);
    // } else {
    this.groupByRowNode(rowNode);
    // }

    return;
  }

  private groupByRowNode(rootNode: RowNode): void {
    const { getRowNodeId, getLevel } = this;
    const rowNodeIndex = keyBy<RowNode>(rootNode.allLeafChildren, (node) => getRowNodeId(node.data));

    const stack = [rootNode];
    while (stack.length) {
      const node = stack.pop()!; // tslint:disable-line:no-non-null-assertion

      const children = getLevel(node.data);
      const isGroup = children ? children.length > 0 : false;

      if (node !== rootNode) {
        node.group = isGroup;
        node.expanded = this.isNodeOpened(node);
      }
      if (isGroup) {
        // tslint:disable-next-line:no-non-null-assertion
        const childNodes = children!.map((childId) => rowNodeIndex[childId]).filter(Boolean);
        node.childrenAfterGroup = childNodes;
        childNodes.forEach((childNode) => stack.push(childNode));
      } else {
        node.childrenAfterGroup = [];
      }
    }
  }

  private isNodeOpened(node: RowNode): boolean {
    const { expanded } = this;
    return expanded ? node.data[this.expanded] : false;
  }
}
